import ConditionalInfoHeader from './ConditionalInfoHeader';

export default ConditionalInfoHeader;
